import React, { useState } from "react";
import IconButton from "@mui/material/IconButton";
import DifferenceIcon from "@mui/icons-material/Difference";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import Box from "@mui/material/Box";
import { uploadExcelFile } from "../../api/Customer/customerApi";

const ExcelUpload = () => {
  const [file, setFile] = useState(null);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleUpload = async () => {
    if (file) {
      const formData = new FormData();
      formData.append("file", file);

      try {
        await uploadExcelFile(formData); // API call to upload and process the file
        alert("File uploaded successfully");
      } catch (error) {
        console.error("Error uploading file:", error);
        alert("Failed to upload file");
      }
    } else {
      alert("Please select a file first");
    }
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      {/* Hidden file input */}
      <input
        type="file"
        id="fileUpload"
        accept=".xlsx, .xls"
        style={{ display: "none" }}
        onChange={handleFileChange}
      />
      {/* Custom file upload button */}
      <label htmlFor="fileUpload">
        <IconButton
          aria-label="select file"
          size="large"
          component="span"
          disabled
          sx={{
            background: "#90b2b7",
            color: "#000",
            border: "1px solid #90b2b7",
          }}
        >
          <DifferenceIcon fontSize="inherit" />
        </IconButton>
      </label>
      {file && (
        <>
          <span style={{ marginLeft: "10px", fontSize: "14px" }}>
            {file.name}
          </span>
          <IconButton
            aria-label="upload file"
            size="large"
            onClick={handleUpload}
            style={{ marginLeft: "10px", background: "#90b2b7", color: "#000" }}
          >
            <CloudUploadIcon fontSize="inherit" />
          </IconButton>
        </>
      )}
    </Box>
  );
};

export default ExcelUpload;
